import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';

import { Field, reduxForm } from 'redux-form';

import { getTranslatedString } from 'helpers/i18n';
import FlatButton from 'material-ui/FlatButton';

import { PulseLoader } from 'halogenium';

import { AccentColor } from 'helpers/AccentColorHelper';
import * as validator from 'helpers/Validator';
import { deepDiver } from 'helpers/utilities';
import { MuiThemeProvider } from '@material-ui/core';
import { muiThemeNext16px } from 'helpers/MUIFiles';
import LanguageOptionsCentered from 'components/shared/LanguageOptionsCentered';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';

class RegistrationForm extends Component {
  passwordStrength = () => {
    const query = browserHistory.getCurrentLocation().query;

    if (query.user_type === 'maintenance' || query['amp;user_type'] === 'maintenance') {
      return [validator.required, validator.passwordStrengthWeak];
    }

    return [validator.required, validator.passwordStrength];
  };

  onLanguageChange = () => {
    this.forceUpdate();
    this.props.forceUpdate();
  };

  render() {
    const style = {
      button: {
        marginTop: '20px',
        width: '100%',
        color: 'white',
        fontSize: '18px',
        height: '50px',
      },
    };

    const { handleSubmit, submitting, initialValues } = this.props;

    let emailDisabled = this.props.emailDisabled === true;

    let require_email = [validator.validEmail];
    if (!emailDisabled) {
      require_email = [validator.required, validator.validEmail];
    }

    return (
      <MuiThemeProvider theme={muiThemeNext16px(AccentColor())}>
        <form onSubmit={handleSubmit}>
          {!initialValues && (
            <React.Fragment>
              <Field
                name="first_name"
                autocomplete="off"
                component={TextField}
                floatingLabelText={getTranslatedString('firstName')}
                label={getTranslatedString('firstName')}
                validate={[validator.required]}
                errorStyle={{
                  bottom: '-3px',
                  lineHeight: '6px',
                  marginBottom: '-7px',
                }}
                variant="outlined"
                style={{ marginTop: '5px' }}
              />
              <Field
                name="last_name"
                autocomplete="off"
                component={TextField}
                floatingLabelText={getTranslatedString('lastName')}
                label={getTranslatedString('lastName')}
                validate={[validator.required]}
                errorStyle={{
                  bottom: '-3px',
                  lineHeight: '6px',
                  marginBottom: '-7px',
                }}
                variant="outlined"
                style={{ marginTop: '20px' }}
              />
              <Field
                name="phone_number"
                autocomplete="off"
                component={ReactPhoneInput}
                floatingLabelText={getTranslatedString('phoneNumber')}
                label={getTranslatedString('phoneNumber')}
                validate={[validator.required, validator.validInternationalPhoneNumber]}
                errorStyle={{
                  bottom: '-3px',
                  lineHeight: '6px',
                  marginBottom: '-7px',
                }}
                variant="outlined"
                style={{ marginTop: '20px' }}
              />
            </React.Fragment>
          )}

          <Field
            name="email"
            autocomplete="off"
            type="email"
            component={TextField}
            floatingLabelText={getTranslatedString('email')}
            label={getTranslatedString('email')}
            validate={require_email}
            errorStyle={{
              bottom: '-3px',
              lineHeight: '6px',
              marginBottom: '-7px',
            }}
            disabled={emailDisabled}
            variant="outlined"
            style={{ marginTop: '20px' }}
          />
          {this.renderVerificationStepField()}
          <Field
            name="password"
            autocomplete="off"
            component={TextField}
            floatingLabelText={getTranslatedString('password')}
            label={getTranslatedString('password')}
            type="password"
            validate={this.passwordStrength()}
            errorStyle={{
              bottom: '-3px',
              lineHeight: '14px',
              marginBottom: '-7px',
            }}
            variant="outlined"
            style={{ marginTop: '20px' }}
          />
          <Field
            name="password_confirmation"
            autocomplete="off"
            component={TextField}
            floatingLabelText={getTranslatedString('repeatPassword')}
            label={getTranslatedString('repeatPassword')}
            type="password"
            validate={[validator.required, validator.passwordConfirmation]}
            errorStyle={{
              bottom: '-3px',
              lineHeight: '14px',
              marginBottom: '-7px',
            }}
            variant="outlined"
            style={{ marginTop: '20px' }}
          />
          <FlatButton
            label={this.props.submitMessage}
            primary={true}
            type="submit"
            backgroundColor={AccentColor()}
            hoverColor="grey"
            style={style.button}
            labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
            disabled={submitting}
          />
          <div style={{ marginTop: '10px' }}>
            <LanguageOptionsCentered onLanguageChange={this.onLanguageChange} />
          </div>

          {this.props.isRegistering && (
            <div className="row">
              <span
                style={{
                  textAlign: 'center',
                  width: '108px',
                  margin: 'auto',
                  position: 'absolute',
                  marginTop: '-25px',
                  zIndex: 1,
                  marginLeft: '28px',
                }}
              >
                <PulseLoader color="#fff" size="4" />
              </span>
            </div>
          )}
        </form>
      </MuiThemeProvider>
    );
  }

  renderVerificationStepField = () => {
    if (!deepDiver(this.props.initialValues, 'verification_step')) return null;

    return (
      <Field
        name="verification_answer"
        component={OutlinedSelect}
        label={getTranslatedString('unitYouAreRenting')}
        validate={[validator.required]}
        style={{ marginTop: '20px' }}
        options={this.props.initialValues.verification_options}
      />
    );
  };
}

let registrationForm = reduxForm({
  form: 'registrationForm', // a unique identifier for this form
  enableReinitialize: true,
})(RegistrationForm);

export default registrationForm;
